exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "#patternSidebar {\r\n  max-width: 500px;\r\n  box-shadow: 0 2px 4px #ccc;\r\n  border-left: none;\r\n}\r\n\r\n#patternSidebar .toggleButtonWrapper {\r\n  background: teal;\r\n}", ""]);

// exports
